module.exports = __webpack_public_path__ + "static/media/logo-terra.1650ce94.svg";